import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import  PageHeader  from './PageHeader';
import  getAppConfigParm  from '../config/AppConfig';
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
// import { sendResetPwMail } from '../actions/auth'; 
// import { GoogleAdInit } from './advertisement/GoogleAdInit';


// This page is merely a confirmation page, letting user know that the email they submitted
// via the ForgotPwPage, was successfully sent and they should check their inbox for instructions
export class ForgotPwPage2 extends React.Component { 

    // Allows user to get rid of message box by hitting Ok button.
    handleOk = () => {
        this.props.history.push('/');    
    };
     
    // This renders the confirmation box, letting user know email has been sent.
    // Notice that page is using some css modifiers as general helpers.
    render() {

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");

        return (
            <div> 
            <Helmet>
            <title>Forgot Password Email Notification</title>
            <meta name="description" content="Forgot Password Email Notification" />
        </Helmet>
               <PageHeader />
                <VisibilityWrapper show={showAd} contentType="advertisement" >
                    <div className="ad-leaderboard-container rc-flex-container-center-hv">
                        <h3 className="ad-web-leaderboard">-- Add Section - Web Leader board --</h3>
                        <h3 className="ad-mobile-leaderboard">-- Add Section - Mobile Leader board</h3>
                    </div>
               </VisibilityWrapper>
               <div className="app-container-alt3">    
                   <div className="app-content-container"> 
                        <div className="form-forgotpw" >
                            <h3 className="form-forgotpw2-msg">{this.props.auth.message}</h3> 
                            <button type="button" className="button button--oval color-w" 
                                onClick={this.handleOk} >
                                OK 
                            </button>   
                       </div>
                    </div>
               </div>
               
            </div>
        );
    };
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps)(ForgotPwPage2);





// WEBPACK FOOTER //
// ./src/components/ForgotPwPage2.js